import { useMemo } from 'react';
import { buildInquirySummary } from '../inquiryPackageModel';

const useInquiryPackageSummary = ({ listing, formValues, intl }) =>
  useMemo(() => buildInquirySummary({ listing, formValues, intl }), [listing, formValues, intl]);

export default useInquiryPackageSummary;
